import { render, staticRenderFns } from "./IconTrash.vue?vue&type=template&id=605255a5&scoped=true"
import script from "./IconTrash.vue?vue&type=script&lang=js"
export * from "./IconTrash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605255a5",
  null
  
)

export default component.exports